import React from 'react';
import './SuperAdminStyles.css';

const BusinessManagement = () => {
  return (
    <div className="business-management">
      <h2>Business Management</h2>
      <div className="business-container">
        <div className="business-card">
          <h3>Business Registration</h3>
          <p>Register and manage multiple business entities.</p>
        </div>
        <div className="business-card">
          <h3>Location Management</h3>
          <p>Manage business locations and branches.</p>
        </div>
        <div className="business-card">
          <h3>Subscription Plans</h3>
          <p>Manage subscription plans and billing for businesses.</p>
        </div>
      </div>
    </div>
  );
};

export default BusinessManagement;
